import { renderOptions, withDimensionItems } from "./helpers";
import i18n, { t } from "i18next";

export const mapTransportationAndDistributionFormData = (formData, transportTypes) => {
  if (transportTypes) {
    return formData.map(row => {
      const mapped = {
        id: row.id ?? null,
        typeOfTransport: transportTypes.find(type => type.code === row.typeOfTransport)?.id ?? "",
        subtypeOfTransport: transportTypes.find(type => type.code === row.typeOfTransport)?.subtypes?.find(
          sub => sub.code === row.subtypeOfTransport)?.id ?? "",
        subtypeTwo: row.subtypeTwo !== "" ?
          transportTypes.find(type => type.code === row.typeOfTransport)?.subtypes?.find(
            sub => sub.code === row.subtypeOfTransport)?.subtypeTwos?.find(
            sub2 => sub2.code === row.subtypeTwo)?.id ?? "" : "",
        unit: transportTypes.find(type => type.code === row.typeOfTransport)?.units?.find(
          unt => unt.code === row.unit)?.id,
        value: row.value,
        // ESG-3894: carry dimension fields through so withDimensionItems can nest them.
        dimensionOneItem: row.dimensionOneItem,
        dimensionTwoItem: row.dimensionTwoItem,
        dimensionThreeItem: row.dimensionThreeItem,
        dimensionFourItem: row.dimensionFourItem,
        dimensionFiveItem: row.dimensionFiveItem
      };
      return withDimensionItems(mapped);
    })
  }
  return [];
};

export const mapTransportationAndDistributionApiData = (apiData, transportTypes) => {
  if (transportTypes) {
    return apiData.map(row => {
      return {
        id: row.id ?? null,
        typeOfTransport: transportTypes.find(type => type.id === row.typeOfTransport)?.code ?? "",
        subtypeOfTransport: transportTypes.find(type => type.id === row.typeOfTransport)?.subtypes?.find(
          sub => sub.id === row.subtypeOfTransport)?.code ?? "",
        subtypeTwo: row.subtypeTwo !== "" ?
          transportTypes.find(type => type.id === row.typeOfTransport)?.subtypes?.find(
            sub => sub.id === row.subtypeOfTransport)?.subtypeTwos?.find(
            sub2 => sub2.id === row.subtypeTwo)?.code ?? "" : "",
        unit: transportTypes.find(type => type.id === row.typeOfTransport)?.units?.find(
          unt => unt.id === row.unit)?.code,
        value: row.value
      }
    });
  }
  return [];
};

export const transportTypesWithRequiredSubtypeTwo = ["VANS", "FREIGHT_FLIGHTS", "SEA_TANKER", "CARGO_SHIP"];

export const renderTypeOfTransportOptions = (transportTypes) => {
  const sortedTypes = transportTypes?.sort(sortAlphabeticallyByName) ?? [];
  const optionsArr = sortedTypes.map(el => el.code) ?? [];
  const alternativeLabels = sortedTypes.map(el => el.name) ?? [];
  const translationKey =
    "organizationQuestionnaire.scope3.inputs.upstreamTransportationAndDistribution.typeOfTransport.options";

  return renderOptions(optionsArr, translationKey, alternativeLabels);
};

export const renderSubTypeOfTransportOptions = (transportTypes, selectedTypeOfTransport) => {
  const foundObj = transportTypes?.find(el => el.code === selectedTypeOfTransport);
  const sortedSubTypes = foundObj?.subtypes?.sort(sortAlphabeticallyByName) ?? [];
  const optionsArr = sortedSubTypes.map(subtype => subtype.code) ?? [];
  const alternativeLabels = sortedSubTypes.map(el => el.name) ?? [];
  const translationKey =
    "organizationQuestionnaire.scope3.inputs.upstreamTransportationAndDistribution.subtypeOfTransport.options";

  return renderOptions(optionsArr, translationKey, alternativeLabels);
};

export const renderSubTypeTwoOptions = (transportTypes, selectedType, selectedSubType) => {
  const foundObj = transportTypes?.find(el => el.code === selectedType)?.subtypes?.find(sub => sub.code === selectedSubType);
  const sortedElements = foundObj?.subtypeTwos?.sort(sortAlphabeticallyByName) ?? [];
  const optionsArr = sortedElements.map(subtypeTwo => subtypeTwo.code) ?? [];
  const alternativeLabels = sortedElements.map(subtypeTwo => subtypeTwo.name) ?? [];
  const translationKey =
    "organizationQuestionnaire.scope3.inputs.upstreamTransportationAndDistribution.subtypeTwo.options";

  return renderOptions(optionsArr, translationKey, alternativeLabels);
};

export const renderUnitOptions = (transportTypes, selectedTypeOfTransport) => {
  const foundObj = transportTypes?.find(el => el.code === selectedTypeOfTransport);
  const sortedUnits = foundObj?.units?.sort(sortAlphabeticallyByName) ?? [];
  const optionsArr = sortedUnits.map(unit => unit.code) ?? [];
  const alternativeLabels = sortedUnits.map(unit => unit.name) ?? [];
  const translationKey =
    "organizationQuestionnaire.scope3.inputs.upstreamTransportationAndDistribution.unit.options";

  return renderOptions(optionsArr, translationKey, alternativeLabels);
};

export const getLabel = (attribute, selectedValue, alternativeName) => {
  return i18n.exists(`organizationQuestionnaire.scope3.inputs.upstreamTransportationAndDistribution.${attribute}.options.${selectedValue}`) ?
    t(`organizationQuestionnaire.scope3.inputs.upstreamTransportationAndDistribution.${attribute}.options.${selectedValue}`) :
    alternativeName !== "" ? alternativeName : selectedValue;
};

export const sortAlphabeticallyByName = (a, b) => {
  return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
};